<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Zakljucaj rezervaciju</b></div>
            </div>              
            <!-- Reservation Lock -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="visible-for-all">Zakljucaj sto broj: ##</label>
                <div class="c-btn-as-switch" v-bind:class="{'c-active' : formVars.lockTable.model}" v-on:click="formVars.lockTable.model = !formVars.lockTable.model">
                  <div class="c-options-hint-back-wrapper">
                    <div class="c-grid-row"><div class="c-col-6"><b>NE</b></div><div class="c-col-6"><b>DA</b></div></div>
                  </div>
                  <button class="c-btn c-btn-slider">
                    <div class="c-align-this">
                      <span class="c-has-vertical-lines c-left"></span>
                      <b v-if="formVars.lockTable.model == true" class="c-ux-color-success">DA</b>
                      <b v-else class="c-ux-color-danger">NE</b>
                      <span class="c-has-vertical-lines c-right"></span>
                    </div>
                  </button>
                </div>
                <!-- <div class="c-form-switch">
                  <label class="c-switch-button">
                    <input type="checkbox" v-on:click="formVars.lockTable.model = !formVars.lockTable.model" v-model="formVars.lockTable.model">
                    <div class="c-slider">
                      <div class="c-options-hint-back-wrapper">
                        <div class="c-grid-row"><div class="c-col-6"><b>NE</b></div><div class="c-col-6"><b>DA</b></div></div>
                      </div>
                      <span class="c-slider-btn">
                        <div class="c-align-this">
                          <span class="c-has-vertical-lines c-left"></span>
                          <b v-if="formVars.lockTable.model == true" class="c-ux-color-success">DA</b>
                          <b v-else class="c-ux-color-danger">NE</b>
                          <span class="c-has-vertical-lines c-right"></span>
                        </div>
                      </span>
                    </div>
                  </label>
                </div> -->
              </div>
            </div>
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>

import router from '@/router/index'
import EventBus from '@/EventBus'
import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalQuickLock',
  props: ['inputModalData'],
  data () {
    return {
      msg: 'ModalQuickLock modal',
      resolve: null,
      reject: null,
      // ~ received object of event that we want to show
      eventUid: null,
      currentFirebaseUser: null,
      formVars: {
        isValid: false,
        lockTable: {
          model: null,
          listOfAllTables: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      }
    }
  },
  methods: {
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      firebaseDB.ref().child('/listOfAllEventsReservations/' + this.eventUid + '/' + this.inputModalData.dataForModal.selectedReservationItem.uid).update({
        tableLocked: {
          status: (this.formVars.lockTable.model) ? this.formVars.lockTable.model : null,
          lockedByUserUid: (this.formVars.lockTable.model == true) ? this.currentFirebaseUser.currentUser.uid : null,
          lockedByUserName: (this.formVars.lockTable.model == true) ? this.currentFirebaseUser.userDetails.firstName : null,
          lockedDate: (this.formVars.lockTable.model == true) ? moment().utc().locale('en').toISOString() : null
        }
      }).then(
        function (response) {
          //console.log('Modal Quick Lock Update succ: ' + JSON.stringify(response, null, 2));
          var resultToReturn = {
            tempMsg: 'ModalQuickLock returns Yes'
          }
          this.resolve(resultToReturn);
        }.bind(this),
        function (error){
          console.log('Modal Quick Lock Update ERROR: ' + JSON.stringify(error, null, 2));
        }.bind(this)
      );
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    },  
  },
  created () {
    //console.log('~ created- ModalQuickLock component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedReservationItem && this.inputModalData.dataForModal.selectedReservationItem.tableLocked){
        this.formVars.lockTable.model = (this.inputModalData.dataForModal.selectedReservationItem.tableLocked.status) ? this.inputModalData.dataForModal.selectedReservationItem.tableLocked.status : false;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.eventUid){
        this.eventUid = this.inputModalData.dataForModal.eventUid;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.currentFirebaseUser){
        this.currentFirebaseUser = this.inputModalData.dataForModal.currentFirebaseUser;
      }
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalQuickLock component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalQuickLock component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalQuickLock.vue